import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AccordionItemHeading, AccordionItemButton } from 'react-accessible-accordion';
import Actions from './props/Actions';
import { AttachmentList } from '../../../components/Attachments';
import { setActiveActivityBox } from '../../../store/Activities/index';
import constants from '../../../constants';

const Email = (props) => {
    let { activity, activityData, onUpdateActivity } = props;
    let [hovered, setHovered] = useState(false);
    const dispatch = useDispatch();
    const { singlePageData } = useSelector(state => state['SinglePage']);

    const handleReply = (e) => {
        e.stopPropagation();
        const replyTo = activity?.direction === 'inbound'
            ? (activity?.metadata?.from || '')
            : (activity?.metadata?.to || '');
        const originalSubject = activity?.metadata?.subject || activity?.emailSubject || activity?.title?.replace('Email: ', '') || '';
        const replySubject = originalSubject.startsWith('Re:') ? originalSubject : `Re: ${originalSubject}`;

        const schema = constants.getObjectSchema(singlePageData?.objectType);
        const associations = schema ? { [schema.plural]: [singlePageData['_id']] } : { contacts: singlePageData?.['_id'] ? [singlePageData['_id']] : [] };

        dispatch(setActiveActivityBox({
            activityBox: 'email',
            associations,
            emailReplyData: {
                mode: 'reply',
                to: replyTo,
                subject: replySubject,
                body: `<br/><br/><div style="border-left: 2px solid #ccc; padding-left: 10px; margin-left: 5px; color: #666;">
                    <p><strong>On ${activityData?.createdAt}, ${activity?.direction === 'inbound' ? activity?.metadata?.from : activityData?.createdBy} wrote:</strong></p>
                    ${activity?.description || ''}
                </div>`,
                threadId: activity?.metadata?.threadId || null,
                inReplyTo: activity?.metadata?.internetMessageId || activity?.metadata?.messageId || null
            }
        }));
    };

    const handleForward = (e) => {
        e.stopPropagation();
        const originalSubject = activity?.metadata?.subject || activity?.emailSubject || activity?.title?.replace('Email: ', '') || '';
        const fwdSubject = originalSubject.startsWith('Fwd:') ? originalSubject : `Fwd: ${originalSubject}`;
        const fromInfo = activity?.direction === 'inbound' ? activity?.metadata?.from : activityData?.createdBy;
        const toInfo = activity?.direction === 'inbound' ? activityData?.createdBy : activity?.metadata?.to;

        const fwdSchema = constants.getObjectSchema(singlePageData?.objectType);
        const fwdAssociations = fwdSchema ? { [fwdSchema.plural]: [singlePageData['_id']] } : { contacts: singlePageData?.['_id'] ? [singlePageData['_id']] : [] };
        dispatch(setActiveActivityBox({
            activityBox: 'email',
            associations: fwdAssociations,
            emailReplyData: {
                mode: 'forward',
                to: '',
                subject: fwdSubject,
                body: `<br/><br/><div style="border-left: 2px solid #ccc; padding-left: 10px; margin-left: 5px; color: #666;">
                    <p>---------- Forwarded message ----------</p>
                    <p><strong>From:</strong> ${fromInfo || 'unknown'}</p>
                    <p><strong>To:</strong> ${toInfo || 'unknown'}</p>
                    <p><strong>Date:</strong> ${activityData?.createdAt}</p>
                    <p><strong>Subject:</strong> ${originalSubject}</p>
                    <br/>
                    ${activity?.description || ''}
                </div>`,
                threadId: null,
                inReplyTo: null
            }
        }));
    };

    const getStatusBackgroundColor = (status) => {
        const colors = {
            'completed': '#F0FDF4',
            'pending': '#FFF6F2',
            'cancelled': '#FFF2F2',
            'in-progress': '#EFF6FF'
        };
        return colors[status] || '#6c757d';
    };

    const getStatusColor = (status) => {
        const colors = {
            'completed': '#16A34A',
            'pending': '#EA580C',
            'cancelled': '#EA580C',
            'in-progress': '#2563EB'
        };
        return colors[status] || '#6c757d';
    };

    const getPriorityBackgroundColor = (priority) => {
        const colors = {
            'urgent': '#FFF2F2',
            'high': '#FFF6F2',
            'medium': '#EFF6FF',
            'low': '#6c757d'
        };
        return colors[priority] || '#6c757d';
    };
    const getPriorityColor = (priority) => {
        const colors = {
            'urgent': '#EF4D56',
            'high': '#EA580C',
            'medium': '#2563EB',
            'low': '#6c757d'
        };
        return colors[priority] || '#6c757d';
    };

    return (
        <>
            <AccordionItemHeading>
                <AccordionItemButton>
                    <div className="activity-card email-card">
                        <div className="activity-header">
                            <div className="activity-type-info">
                                <div className="activity-icon email-icon">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <div className="activity-details">
                                    <div className="activity-title">
                                        <span className="activity-type-label">
                                            {activity?.direction === 'inbound' ? 'Incoming Email' : 'Email'}
                                        </span>
                                        <span className="activity-subject">
                                            {activity?.emailSubject || activity?.title || 'Email sent'}
                                        </span>
                                    </div>
                                    <div className="activity-meta">
                                        <span className="created-by">
                                            {activity?.direction === 'inbound'
                                                ? `from ${activity?.metadata?.from || 'unknown'}`
                                                : `by ${activityData?.createdBy}`}
                                        </span>
                                        {activity?.metadata?.to && activity?.direction !== 'inbound' && (
                                            <span className="recipient">to {activity.metadata.to}</span>
                                        )}

                                        <div className="activity-badges">
                                            <span
                                                className="status-badge"
                                                style={{ backgroundColor: getStatusBackgroundColor(activity?.status), color: getStatusColor(activity?.status) }}
                                            >
                                                {activity?.status || 'completed'}
                                            </span>
                                            <span
                                                className="priority-badge"
                                                style={{ backgroundColor: getPriorityBackgroundColor(activity?.priority), color: getPriorityColor(activity?.status) }}
                                            >
                                                {activity?.priority || 'medium'}
                                            </span>
                                            {activity?.metadata?.source && (
                                                <span
                                                    className="source-badge"
                                                    style={{
                                                        backgroundColor: activity.metadata.source === 'manual' ? '#6c757d' : activity.metadata.source === 'gmail_push' ? '#16A34A' : '#007bff',
                                                        color: '#fff',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px',
                                                        fontSize: '11px',
                                                        fontWeight: '500'
                                                    }}
                                                >
                                                    {activity.metadata.source === 'manual' ? 'Manual' : activity.metadata.source === 'gmail_push' ? 'Received' : 'Workflow'}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>



                            <div className="activity-actions" onClick={(e) => e.stopPropagation()}>
                                <button className="email-reply-btn" onClick={handleReply}>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z" fill="currentColor"/>
                                    </svg>
                                    Reply
                                </button>
                                <button className="email-forward-btn" onClick={handleForward}>
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 9V5L21 12L14 19V14.9C9 14.9 5.5 16.5 3 20C4 15 7 10 14 9Z" fill="currentColor"/>
                                    </svg>
                                    Forward
                                </button>
                                <Actions {...props} />
                                <span className="activity-time">{activityData?.createdAt}</span>
                            </div>
                        </div>

                        {activity?.description && (
                            <div className="activity-description">
                                <p dangerouslySetInnerHTML={{ __html: activity.description }}></p>
                            </div>
                        )}

                        {activity?.metadata?.workflowId && (
                            <div className="activity-metadata">
                                <div className="metadata-item">
                                    <strong>Via Workflow</strong>
                                    <span className="workflow-badge">Automated</span>
                                </div>
                            </div>
                        )}

                        {/* Attachments Section */}
                        {activity['attachments'] && activity['attachments'].length > 0 && (
                            <div className="activity-attachments" style={{ marginTop: '10px' }}>
                                <AttachmentList 
                                    attachments={activity['attachments']} 
                                    showUploadedBy={false}
                                    enableActions={false}
                                />
                            </div>
                        )}
                    </div>
                </AccordionItemButton>
            </AccordionItemHeading>
        </>
    );
};

export default Email;